import { get } from "js-cookie";
import { useState } from "react";
import {
  GetAccountInfoQueryVariables,
  useGetAccountInfoQuery,
} from "views/utils/graphql/graphql";

export const useGetAccountInfo = (
  initVariables: GetAccountInfoQueryVariables,
  pause: boolean
) => {
  const [variables, setVariables] =
    useState<GetAccountInfoQueryVariables>(initVariables);
  const [accountInfo, getAccountInfo] = useGetAccountInfoQuery({
    variables,
    requestPolicy: "network-only",
    pause: pause,
  });

  return {
    accountInfo,
    getAccountInfo,
    setVariables,
  };
};
